<section class="dashboard">
    <div class="dashboard-lead-card">
        <div class="dashboard-lead-card-header">
            <span class="icon dashboard-lead-card-header-icon-box" svgIcon="assets/svg/icons/id-card-gb.svg"></span>
            <h3 class="dashboard-lead-card-header-title">
                Your Aadhaar E-KYC has expired. Update it again to continue
            </h3>
        </div>
        <div class="dashboard-lead-card-body">
            <div class="dashboard-lead-card-body-content">
                <button type="button" class="primary-gradient-btn btn-w100 apply-btn" (click)="aadhaarKyc()">
                    Update Aadhaar <img class="icon icon-primary" src="assets/svg/icons/arrow-right-up.svg" />
                </button>
            </div>
        </div>
    </div>
</section>
